import { Component, EventEmitter, InputSignal, Output, OutputEmitterRef, input, output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Modal } from '../../../models/component/modal.model';

@Component({
  selector: 'app-headband',
  standalone: true,
  imports: [],
  templateUrl: './headband.component.html',
  styleUrl: './headband.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-5em)' }),
        animate('300ms ease-in', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateY(0)' }),
        animate('300ms ease-out', style({ opacity: 0, transform: 'translateY(-5em)' })),
      ]),
    ]),
  ],
})
export class HeadbandComponent {
  display: InputSignal<boolean> = input<boolean>(false);
  type: InputSignal<Modal.Type> = input<Modal.Type>('info');
  title: InputSignal<string> = input<string>('');
  content: InputSignal<string> = input<string>('');
  primaryBtnLabel: InputSignal<string> = input<string>('');
  secondaryBtnLabel: InputSignal<string> = input<string>('');

  bntCallback: OutputEmitterRef<boolean> = output<boolean>();
  closeCrossCallback: OutputEmitterRef<void> = output();

  onCLick(value: boolean) {
    this.bntCallback.emit(value);
  }

  onClose() {
    this.closeCrossCallback.emit();
  }
}
